const globalStyles = {
  "@global": {
    body: {
      margin: 0,
    },
    "h1, h2, h3, h4, h5, h6": {
      fontFamily: "Jost, sans-serif",
      fontWeight: 600,
    },
    "div, button, p": {
      fontFamily: "Jost, sans-serif",
      fontWeight: 400,
    },
  },
}

export const DURATION = "0.2s"
export const FADEIN = "fadeIn"
export const FADEOUT = "fadeOut"

export const SECTION_DURATION = "0.8s"
export const HEADER_FADEIN = "h_fadeIn"
export const HEADER_FADEOUT = "h_fadeOut"
export const QUIZ_FADEIN = "q_fadeIn"
export const QUIZ_FADEOUT = "q_fadeOut"
export const RESULTS_FADEIN = "r_fadeIn"
export const RESULTS_FADEOUT = "r_fadeOut"

export default globalStyles
